module.exports = __webpack_public_path__ + "static/media/hw_me_34.3c4a80e2.flv";